module.exports = __webpack_public_path__ + "img/empty_1@2x.9c1fb0e2.png";